export default "__VITE_ASSET__CU8_KnHA__"